import { render, staticRenderFns } from "./form5.vue?vue&type=template&id=53df5252&scoped=true&"
import script from "./form5.vue?vue&type=script&lang=js&"
export * from "./form5.vue?vue&type=script&lang=js&"
import style0 from "./form5.vue?vue&type=style&index=0&id=53df5252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df5252",
  null
  
)

export default component.exports